import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { RoutingErrorComponent } from './routing-error/routing-error.component';
import { TripGenerationComponent } from './trip-generation/trip-generation.component';

@Component({
  selector: 'app-trips',
  templateUrl: './trips.component.html',
  styleUrls: ['./trips.component.scss']
})
export class TripsComponent implements OnInit, OnDestroy {

  startTimer: boolean = false;
  tripViewFlag: boolean = false;
  headErrorFlag: boolean = false;
  successFlag: boolean = false;
  errorFlag: boolean = true;
  singleList: any[] = [];
  errorSingleList: any[] = [];
  errorList: any[] = [];
  tripList: any[] = [];
  tripvehs: any[] = [];
  cities: any[] = [];
  sites: any[] = [];
  sub: Subscription;
  selectedCityId: any;
  selectedCity: any = '';
  selectedSite: any = '';
  siteId: any = '';
  selectedShiftType: any;
  tripDate: any = new Date();
  generatedShift: any;
  headErrorMsg: any;
  shiftTypes: any[] = ["IN", "OUT", "ALL"];
  activeTabId = 1;
  generateMsg: any;
  _currentUser: any;
  _facility: any = "";
  facilityData: any;
  hasActiveFacility: boolean = false;
  restrictPastTripGeneration: boolean = false;

  constructor(
    private readonly apiService: ApiService,
    private serviceSharedData: ServiceSharedData,
    private serviceLocalStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  get showFacilityFilter(): boolean {
    return this.hasActiveFacility;
  }

  ngOnInit() {
    this.getRolePermissions();
    setTimeout(() => {
      this._currentUser = this.serviceLocalStorage.getUserObject();
      const sharedData = ServiceSharedData.TRIP_GENERATION;
      const data = {
        locationsList: this.serviceSharedData.getData(sharedData.locationsList),
        sitesList: this.serviceSharedData.getData(sharedData.sitesList),
        location: this.serviceSharedData.getData(sharedData.location),
        site: this.serviceSharedData.getData(sharedData.site),
        date: this.serviceSharedData.getData(sharedData.date),
        shiftType: this.serviceSharedData.getData(sharedData.shiftType),
        tripViewFlag: this.serviceSharedData.getData(sharedData.tripViewFlag),
        saveTripMirroringFlag: this.serviceSharedData.getData(sharedData.saveTripMirroringFlag),
        facility: this.serviceSharedData.getData(ServiceSharedData.TRIP_GENERATION_FACILITY.facility)
      };

      const { facility, ...coreTripData } = data;
      if (Object.values(coreTripData).every(Boolean) && data.tripViewFlag) {
        Object.assign(this, {
          cities: data.locationsList,
          sites: data.sitesList,
          selectedCityId: data.location,
          selectedCity: data.location.target.value,
          siteId: data.site.siteId,
          selectedSite: data.site,
          tripDate: data.date,
          selectedShiftType: data.shiftType,
          _facility: facility || ''
        });
        this.fetchHasActiveFacilityBySiteId(this.siteId);

        if (data.saveTripMirroringFlag) {
          this.generatedShift = this.serviceSharedData.getData(sharedData.shiftId);
          this.startTimer = true;
          this.showTrips(true);
        } else {
          this.startTimer = false;
          this.showTrips(false);
        }
        this.serviceSharedData.setData(sharedData.tripViewFlag, false);
        this.serviceSharedData.setData(sharedData.saveTripMirroringFlag, false);
      } else {
        this.selectedShiftType = this.shiftTypes[2];
        const fromTripView = sessionStorage.getItem('fromTripView');
        if (fromTripView === 'true') {
          sessionStorage.removeItem('fromTripView');
          this.loadCitiesAndRestoreFilters(true);
        } else {
          this.loadCitiesAndRestoreFilters(false);
        }
      }
      this.startInterval();
    }, 0);
  }

  saveFilters() {
    let filters: any;
    if (this.hasActiveFacility) {
      filters = {
        selectedCity: this.selectedCity,
        siteId: this.siteId,
        tripDate: this.tripDate,
        selectedShiftType: this.selectedShiftType,
        facility: this._facility
      };
    }
    else {
      filters = {
        selectedCity: this.selectedCity,
        siteId: this.siteId,
        tripDate: this.tripDate,
        selectedShiftType: this.selectedShiftType,
      };
    }
    sessionStorage.setItem('tripFilters', JSON.stringify(filters));
  }

  ngOnDestroy() {
    this.stopInterval();
  }

  startInterval() {
    if (this.generateMsg) {
      this.sub = interval(12000).subscribe(val => {
        if (this.startTimer) this.refreshTrips(true);
      });
    } else {
      this.sub = interval(12000).subscribe(val => {
        if (this.startTimer) this.showTrips(true);
      });
    }
  }

  // startInterval() {
  //   this.sub = interval(12000).subscribe(() => {
  //     if (this.startTimer) {
  //       this.generateMsg ? this.refreshTrips(true) : this.showTrips(true);
  //     }
  //   });
  // }

  stopInterval() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  loadCities() {
    const companyId = +this.serviceLocalStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyId, success => {
      if (success.status == 200) {
        this.cities = success.body;
        if (this.cities && this.cities.length > 0) {
          this.selectedCityId = this.cities[0];
          this.selectedCity = this.cities[0].locationId;
          this.getSitesByCityId({ target: { value: this.cities[0].locationId } });
        }
      } else {
        this.cities = [];
        this.notifyService.showInfo("No Location Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  loadCitiesAndRestoreFilters(shouldLoadTrips: boolean) {
    const companyId = +this.serviceLocalStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyId, success => {
      if (success.status == 200) {
        this.cities = success.body;
        if (this.cities && this.cities.length > 0) {
          // Try to restore filters, otherwise use defaults
          const savedFilters = sessionStorage.getItem('tripFilters');
          if (savedFilters && shouldLoadTrips) {
            const filters = JSON.parse(savedFilters);
            if (filters.selectedCity && filters.siteId) {
              this.selectedCity = String(filters.selectedCity);
              this.siteId = String(filters.siteId);
              this.tripDate = new Date(filters.tripDate);
              this.selectedShiftType = filters.selectedShiftType;
              if (filters.facility) {
                this._facility = filters.facility;
              }

              this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + this.selectedCity, success => {
                if (success.status == 200) {
                  this.sites = success.body;
                  this.selectedSite = this.sites.find(s => s.siteId == this.siteId);
                  this.fetchHasActiveFacilityBySiteId(this.siteId);
                  this.showTrips(false);
                }
              }, error => console.log(error));
            }
          } else if (savedFilters && !shouldLoadTrips) {
            const filters = JSON.parse(savedFilters);
            if (filters.selectedCity && filters.siteId) {
              this.selectedCity = String(filters.selectedCity);
              this.siteId = String(filters.siteId);
              this.tripDate = new Date(filters.tripDate);
              this.selectedShiftType = filters.selectedShiftType;
              if (filters.facility) {
                this._facility = filters.facility;
              }

              this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + this.selectedCity, success => {
                if (success.status == 200) {
                  this.sites = success.body;
                  this.selectedSite = this.sites.find(s => s.siteId == this.siteId);
                  this.fetchHasActiveFacilityBySiteId(this.siteId);
                }
              }, error => console.log(error));
            }
          } else {
            // No saved filters, use logged-in user's location and site
            const userLocationId = this._currentUser?.userInfoDetails?.site?.location?.locationId;
            const userSiteId = this._currentUser?.userInfoDetails?.site?.siteId;

            if (userLocationId && userSiteId) {
              this.selectedCity = userLocationId;
              this.siteId = String(userSiteId);
              this.getSitesByCityId({ target: { value: userLocationId } });
            } else {
              // Fallback to first city if user data not available
              this.selectedCityId = this.cities[0];
              this.selectedCity = this.cities[0].locationId;
              this.getSitesByCityId({ target: { value: this.cities[0].locationId } });
            }
          }
        }
      } else {
        this.cities = [];
        this.notifyService.showInfo("No Location Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  getSitesByCityId(event) {
    const locationId = event.target.value;
    this.siteId = '';
    this.selectedSite = '';
    this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + locationId, success => {
      if (success.status == 200) {
        this.sites = success.body;
        this.selectedSite = success.body[0];
        this.siteId = success.body[0].siteId;
        this.fetchHasActiveFacilityBySiteId(this.siteId);
      } else {
        this.sites = [];
        this.hasActiveFacility = false;
        this.notifyService.showInfo("No Site Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  // onChangeSite(event) {
  //   const siteArr = this.sites.filter(site => site.siteId == event.target.value);
  //   this.selectedSite = siteArr[0];
  // }

  onChangeSite(event) {
    this.selectedSite = this.sites.find(site => site.siteId == event.target.value);
    this.fetchHasActiveFacilityBySiteId(this.siteId);
  }

  fetchHasActiveFacilityBySiteId(siteId) {
    if (!siteId) {
      this.hasActiveFacility = false;
      this._facility = '';
      this.facilityData = [];
      return;
    }
    this.apiService.doGetRequestWithResponse(ApiConstants.hasFacilityBySite + siteId, success => {
      if (success.status === 200) {
        this.hasActiveFacility = success.body.hasActiveFacility === true;
        if (this.hasActiveFacility) {
          this.getFacility();
        } else {
          this.facilityData = [];
          this._facility = '';
        }
      } else {
        this.hasActiveFacility = false;
        this.facilityData = [];
        this._facility = '';
      }
    }, error => {
      this.hasActiveFacility = false;
      this.facilityData = [];
      this._facility = '';
      console.error(error);
    });
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return dt + "/" + mm + "/" + d.getFullYear();
  }

  getFacility() {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.getFacilityBySite + this.siteId, success => {
      if (success.status == 200) {
        this.facilityData = success.body;
        this.ngxLoader.stop();
      } else {
        this.facilityData = [];
        this._facility = '';
        this.notifyService.showInfo("No Facility Found!", null)
        this.ngxLoader.stop();
      }
    }, error => {
      console.log(error)
      this.ngxLoader.stop();
    });
  }

  // showTrips(timer) {
  //   this.errorList = [];
  //   if (this.tripDate && this.selectedSite) {
  //     if (!timer)
  //       this.ngxLoader.start();
  //     this.apiService.doGetRequestWithResponse(ApiConstants.tripstats + this.formatDate(this.tripDate) + '&siteid=' + this.selectedSite.siteId +
  //       '&logType=' + this.selectedShiftType, success => {
  //         this.ngxLoader.stop();
  //         this.tripList = [];
  //         this.headErrorFlag = false;
  //         if (success.status == 200) {
  //           success.body.forEach(element => {
  //             if (element) {
  //               if (!element.ERROR) {
  //                 this.tripList.push({
  //                   time: element.SHIFT,
  //                   totalEmp: element.BOOKING,
  //                   femaleEmp: element.FEMALE,
  //                   totalTrips: element.TRIPS,
  //                   totalAdhocEmp: element.ADHOCBOOKING,
  //                   escortTrip: element.SECURITY,
  //                   SHIFTID: element.SHIFTID,
  //                   MSG: element.MSG,
  //                   ERRORMSG: element.ERRORMSG
  //                 });
  //                 this.tripvehs.push({
  //                   Indica: element.Indica,
  //                   TT: element.TT
  //                 });
  //                 if (element.totalTrips > 0 && element.MSG == "")
  //                   this.tripViewFlag = true;
  //                 if (element.TRIPS > 0 && (element.MSG === "" && element.SHIFTID === this.generatedShift)) {
  //                   this.startTimer = false;
  //                 }
  //               } else {
  //                 this.errorList.push({
  //                   ERROR: element.ERROR,
  //                   SHIFTLOG: element.SHIFTLOG,
  //                   SITENAME: element.SITENAME,
  //                   TRIPDATE: element.TRIPDATE,
  //                   ERROR1: element.ERROR1,
  //                   ERROR2: element.ERROR2,
  //                   ERROR3: element.ERROR3
  //                 });
  //               }
  //             }
  //           });
  //           if (this.tripList.length > 0) {
  //             this.getErrorHead();
  //           }
  //           if (this.errorList.length > 0) {
  //             this.showTripGenSuccess();
  //           }
  //         } else {
  //           this.ngxLoader.stop();
  //           this.notifyService.showInfo("No Data Found", null);
  //         }
  //       }, error => {
  //         if (error.status == 500) {
  //           this.notifyService.showInfo("Please wait for a moment..", null);
  //         } else {
  //           this.ngxLoader.stop();
  //           this.notifyService.showInfo("Please wait..", null);
  //         }
  //         this.startTimer = true;
  //       });
  //   } else {
  //     this.notifyService.showWarning("Site / Date is not selected", null);
  //   }
  // }

  showTrips(timer) {
    this.errorList = [];
    if (!this.tripDate || !this.selectedSite) {
      this.notifyService.showWarning("Site / Date is not selected", null);
      return;
    }
    let url: any;
    if (this.hasActiveFacility) {
      url = `${ApiConstants.tripstats}${this.formatDate(this.tripDate)}&siteid=${this.siteId}&logType=${this.selectedShiftType}&facilityIds=${this._facility}`;
    }
    else {
      url = `${ApiConstants.tripstats}${this.formatDate(this.tripDate)}&siteid=${this.siteId}&logType=${this.selectedShiftType}`;
    }
    !timer && this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      url,
      success => {
        this.ngxLoader.stop();
        this.tripList = [];
        this.headErrorFlag = false;
        if (success.status === 200) {
          success.body.filter(Boolean).forEach(element => {
            if (!element.ERROR) {
              this.tripList.push({
                time: element.SHIFT,
                totalEmp: element.BOOKING,
                femaleEmp: element.FEMALE,
                totalTrips: element.TRIPS,
                totalAdhocEmp: element.ADHOCBOOKING,
                escortTrip: element.SECURITY,
                SHIFTID: element.SHIFTID,
                MSG: element.MSG,
                ERRORMSG: element.ERRORMSG
              });

              this.tripvehs.push({
                Indica: element.Indica,
                TT: element.TT
              });
              element.totalTrips > 0 && element.MSG === "" && (this.tripViewFlag = true);
              element.TRIPS > 0 && element.MSG === "" && element.SHIFTID === this.generatedShift && (this.startTimer = false);
            } else {
              this.errorList.push({
                ERROR: element.ERROR,
                SHIFTLOG: element.SHIFTLOG,
                SITENAME: element.SITENAME,
                TRIPDATE: element.TRIPDATE,
                ERROR1: element.ERROR1,
                ERROR2: element.ERROR2,
                ERROR3: element.ERROR3
              });
            }
          });
          this.tripList.length && this.getErrorHead();
          this.errorList.length && this.showTripGenSuccess();
          this.saveFilters();
        } else {
          this.notifyService.showInfo("No Data Found", null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showInfo(error.status === 500 ? "Please wait for a moment.." : "Please wait..", null);
        this.startTimer = true;
      }
    );
  }

  getErrorHead() {
    if (this.tripList[0] != null && this.tripList[0].ERRORMSG) {
      this.headErrorMsg = this.tripList[0].ERRORMSG;
      this.headErrorFlag = true;
    }
  }

  // showTripGenSuccess() {
  //   if (this.errorList) {
  //     this.successFlag = false;
  //     this.errorFlag = false;
  //     this.singleList = [];
  //     this.errorSingleList = [];
  //     this.errorList.forEach(element => {
  //       if (element && element.ERROR != null) {
  //         if (element.ERROR == "SUCC") {
  //           this.successFlag = true;
  //           this.tripViewFlag = true;
  //           this.singleList.push({
  //             ERROR: element.ERROR,
  //             SHIFTLOG: element.SHIFTLOG,
  //             SITENAME: element.SITENAME,
  //             TRIPDATE: element.TRIPDATE,
  //             ERROR1: element.ERROR1,
  //             ERROR2: element.ERROR2,
  //             ERROR3: element.ERROR3
  //           });
  //         } else if (element.ERROR == "ERR") {
  //           this.errorFlag = true;
  //           this.errorSingleList.push({
  //             ERROR: element.ERROR,
  //             SHIFTLOG: element.SHIFTLOG,
  //             SITENAME: element.SITENAME,
  //             TRIPDATE: element.TRIPDATE,
  //             ERROR1: element.ERROR1,
  //             ERROR2: element.ERROR2,
  //             ERROR3: element.ERROR3
  //           });
  //         }
  //       }
  //     });
  //     if (this.successFlag) {
  //       this.tripViewFlag = false;
  //       this.openErrorDialog(this.singleList, true);
  //     } else if (this.errorFlag) {
  //       this.openErrorDialog(this.errorSingleList, false);
  //     }
  //   }
  // }

  showTripGenSuccess() {
    if (!this.errorList?.length) return;
    const validElements = this.errorList.filter(el => el?.ERROR);
    this.singleList = validElements.filter(el => el.ERROR === "SUCC");
    this.errorSingleList = validElements.filter(el => el.ERROR === "ERR");
    this.successFlag = this.singleList.length > 0;
    this.errorFlag = this.errorSingleList.length > 0;
    if (this.successFlag) {
      this.tripViewFlag = false;
      this.openErrorDialog(this.singleList, true);
    } else if (this.errorFlag) {
      this.openErrorDialog(this.errorSingleList, false);
    }
  }

  openErrorDialog(data: any[], type: boolean): void {
    this.generateMsg = '';
    // let d = { type: type, data: data };
    this.successFlag = false;
    this.errorFlag = false;
    this.dialog.open(RoutingErrorComponent, {
      data: { type, data },
      disableClose: true,
      width: "500px"
    });
  }

  viewDetailedTrip(shiftid) {
    sessionStorage.setItem('fromTripView', 'true');
    this.saveFilters();
    const tripGenData = ServiceSharedData.TRIP_GENERATION;
    this.serviceSharedData.setData(tripGenData.locationsList, this.cities);
    this.serviceSharedData.setData(tripGenData.sitesList, this.sites);
    this.serviceSharedData.setData(tripGenData.location, this.selectedCityId);
    this.serviceSharedData.setData(tripGenData.site, this.selectedSite);
    this.serviceSharedData.setData(tripGenData.date, this.tripDate);
    this.serviceSharedData.setData(tripGenData.shiftType, this.selectedShiftType);
    if (this.hasActiveFacility) {
      this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION_FACILITY.facility, this._facility);
    }
    this.router.navigate(["/myatom/routing/tripview", this.selectedSite.siteId, shiftid, this.formatDate(this.tripDate)]);
  }

  // generate(shift) {
  //   this.errorFlag = true;
  //   let tripData;
  //   if (this.tripDate) {
  //     tripData = {
  //       requestedDate: this.formatDate(this.tripDate),
  //       site: this.selectedSite,
  //       shift: shift
  //     };
  //     this.openDialog(tripData);
  //   } else {
  //     this.notifyService.showWarning("Date/site is empty!", null);
  //   }
  // }

  generate(shift) {
    this.errorFlag = true;
    if (!this.tripDate) {
      this.notifyService.showWarning("Date/site is empty!", null);
      return;
    }
    if (this.isPastTripGenerationBlocked()) {
      return;
    }
    this.openDialog({
      requestedDate: this.formatDate(this.tripDate),
      site: this.selectedSite,
      shift: shift
    });
  }

  // openDialog(data: any): void {
  //   this.generateMsg = '';
  //   let dialogRef = this.dialog.open(TripGenerationComponent, {
  //     width: 'auto',
  //     data: data,
  //     disableClose: true
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.generateMsg = result.MSG;
  //       if (result.status === 'onMirroringSubmit') {
  //         this.generatedShift = result.shiftId;
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.locationsList, this.cities);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.sitesList, this.sites);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.location, this.selectedCityId);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.site, this.selectedSite);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.date, this.tripDate);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftType, this.selectedShiftType);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftId, result.shiftId);
  //       } else {
  //         this.generatedShift = result.shiftId;
  //         this.startTimer = true;
  //         this.tripList = [];
  //         this.refreshTrips(false);
  //       }
  //     }
  //   });
  // }

  openDialog(data: any): void {
    this.generateMsg = '';
    const dialogRef = this.dialog.open(TripGenerationComponent, {
      width: 'auto',
      data,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.generateMsg = result.MSG;
      this.generatedShift = result.shiftId;
      if (result.status === 'onMirroringSubmit') {
        const tripGenData = ServiceSharedData.TRIP_GENERATION;
        this.serviceSharedData.setData(tripGenData.locationsList, this.cities);
        this.serviceSharedData.setData(tripGenData.sitesList, this.sites);
        this.serviceSharedData.setData(tripGenData.location, this.selectedCityId);
        this.serviceSharedData.setData(tripGenData.site, this.selectedSite);
        this.serviceSharedData.setData(tripGenData.date, this.tripDate);
        this.serviceSharedData.setData(tripGenData.shiftType, this.selectedShiftType);
        this.serviceSharedData.setData(tripGenData.shiftId, result.shiftId);
        if (this.hasActiveFacility) {
          this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION_FACILITY.facility, this._facility);
        }
      } else {
        this.startTimer = true;
        this.tripList = [];
        this.refreshTrips(false);
      }
    });
  }

  // refreshTrips(timer) {
  //   this.errorList = [];
  //   if (this.tripDate && this.selectedSite) {
  //     if (!timer)
  //       this.ngxLoader.start();
  //     this.apiService.doGetRequestWithResponse(ApiConstants.tripstats + this.formatDate(this.tripDate) + '&siteid=' + this.selectedSite.siteId +
  //       '&logType=' + this.selectedShiftType, success => {
  //         this.headErrorFlag = false;
  //         if (success.status == 200) {
  //           success.body.forEach(element => {
  //             if (element) {
  //               if (element.MSG == '') {
  //                 this.ngxLoader.stop()
  //                 if (!element.ERROR) {
  //                   this.tripList.push({
  //                     time: element.SHIFT,
  //                     totalEmp: element.BOOKING,
  //                     femaleEmp: element.FEMALE,
  //                     totalTrips: element.TRIPS,
  //                     totalAdhocEmp: element.ADHOCBOOKING,
  //                     escortTrip: element.SECURITY,
  //                     SHIFTID: element.SHIFTID,
  //                     MSG: element.SHIFTID == this.generatedShift ? 'Generating' : element.MSG,
  //                     ERRORMSG: element.ERRORMSG
  //                   });
  //                   this.tripvehs.push({
  //                     Indica: element.Indica,
  //                     TT: element.TT
  //                   });
  //                   if (element.totalTrips > 0 && element.MSG == "")
  //                     this.tripViewFlag = true;
  //                   if (element.TRIPS > 0 && (element.MSG === "" && element.SHIFTID === this.generatedShift)) {
  //                     this.startTimer = false;
  //                   }
  //                 } else {
  //                   this.errorList.push({
  //                     ERROR: element.ERROR,
  //                     SHIFTLOG: element.SHIFTLOG,
  //                     SITENAME: element.SITENAME,
  //                     TRIPDATE: element.TRIPDATE,
  //                     ERROR1: element.ERROR1,
  //                     ERROR2: element.ERROR2,
  //                     ERROR3: element.ERROR3
  //                   });
  //                 }
  //               } else {
  //                 this.ngxLoader.stop()
  //                 if (!element.ERROR) {
  //                   this.tripList.push({
  //                     time: element.SHIFT,
  //                     totalEmp: element.BOOKING,
  //                     femaleEmp: element.FEMALE,
  //                     totalTrips: element.TRIPS,
  //                     totalAdhocEmp: element.ADHOCBOOKING,
  //                     escortTrip: element.SECURITY,
  //                     SHIFTID: element.SHIFTID,
  //                     MSG: element.MSG,
  //                     ERRORMSG: element.ERRORMSG
  //                   });
  //                   this.tripvehs.push({
  //                     Indica: element.Indica,
  //                     TT: element.TT
  //                   });
  //                   if (element.totalTrips > 0 && element.MSG == "")
  //                     this.tripViewFlag = true;
  //                   if (element.TRIPS > 0 && (element.MSG === "" && element.SHIFTID === this.generatedShift)) {
  //                     this.startTimer = false;
  //                   }
  //                 } else {
  //                   this.errorList.push({
  //                     ERROR: element.ERROR,
  //                     SHIFTLOG: element.SHIFTLOG,
  //                     SITENAME: element.SITENAME,
  //                     TRIPDATE: element.TRIPDATE,
  //                     ERROR1: element.ERROR1,
  //                     ERROR2: element.ERROR2,
  //                     ERROR3: element.ERROR3
  //                   });
  //                 }
  //               }
  //             }
  //           });
  //           if (this.tripList.length > 0) {
  //             this.getErrorHead();
  //           }
  //           if (this.errorList.length > 0) {
  //             this.showTripGenSuccess();
  //           }
  //         } else {
  //           this.ngxLoader.stop();
  //           this.notifyService.showInfo("No Data Found", null);
  //         }
  //       }, error => {
  //         if (error.status == 500) {
  //           this.notifyService.showInfo("Please wait for a moment..", null);
  //         } else {
  //           this.ngxLoader.stop();
  //           this.notifyService.showInfo("Please wait..", null);
  //         }
  //         this.startTimer = true;
  //       });
  //   } else {
  //     this.notifyService.showWarning("Site / Date is not selected", null);
  //   }
  // }

  refreshTrips(timer: boolean) {
    this.errorList = [];
    if (!this.tripDate || !this.selectedSite) {
      this.notifyService.showWarning("Site / Date is not selected", null);
      return;
    }
    let url: any;
    if (!timer) this.ngxLoader.start();
    if (this.hasActiveFacility) {
      url = `${ApiConstants.tripstats}${this.formatDate(this.tripDate)}&siteid=${this.selectedSite.siteId}&logType=${this.selectedShiftType}&facilityId=${this._facility}`;
    }
    else {
      url = `${ApiConstants.tripstats}${this.formatDate(this.tripDate)}&siteid=${this.selectedSite.siteId}&logType=${this.selectedShiftType}`;
    }
    this.apiService.doGetRequestWithResponse(url,
      success => {
        this.headErrorFlag = false;
        this.ngxLoader.stop();
        if (success.status !== 200) {
          this.notifyService.showInfo("No Data Found", null);
          return;
        }
        success.body.forEach(element => {
          const msgValue = element.MSG === ''
            ? (element.SHIFTID === this.generatedShift ? 'Generating' : element.MSG)
            : element.MSG;
          if (element) {
            const tripData = {
              time: element.SHIFT,
              totalEmp: element.BOOKING,
              femaleEmp: element.FEMALE,
              totalTrips: element.TRIPS,
              totalAdhocEmp: element.ADHOCBOOKING,
              escortTrip: element.SECURITY,
              SHIFTID: element.SHIFTID,
              MSG: msgValue,
              ERRORMSG: element.ERRORMSG
            };
            if (!element.ERROR) {
              this.tripList.push(tripData);
              this.tripvehs.push({ Indica: element.Indica, TT: element.TT });
              if (element.TRIPS > 0 && element.MSG === "" && element.SHIFTID === this.generatedShift) {
                this.startTimer = false;
              }
              if (element.totalTrips > 0 && element.MSG === "") {
                this.tripViewFlag = true;
              }
            } else {
              this.errorList.push({
                ERROR: element.ERROR,
                SHIFTLOG: element.SHIFTLOG,
                SITENAME: element.SITENAME,
                TRIPDATE: element.TRIPDATE,
                ERROR1: element.ERROR1,
                ERROR2: element.ERROR2,
                ERROR3: element.ERROR3
              });
            }
          }
        });
        if (this.tripList.length > 0) this.getErrorHead();
        if (this.errorList.length > 0) this.showTripGenSuccess();
      },
      error => {
        this.startTimer = true;
        if (error.status !== 500) this.ngxLoader.stop();
        this.notifyService.showInfo(error.status === 500 ? "Please wait for a moment.." : "Please wait..", null);
      }
    );
  }

  selectAllFacilities(e: string) {
    const selectedFacility = this._facility;
    const allFacility = this.facilityData.map(element => element.id);
    if (e === 'All') {
      this._facility.setValue(selectedFacility.includes('All') ? allFacility : []);
    }
    else if (selectedFacility.includes('All')) {
      this._facility.setValue(selectedFacility.filter(facility => facility !== 'All'));
    }
  }

  getRolePermissions() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getRolePermissions + parseInt(this.serviceLocalStorage.getRoleId()), success => {
      if (success.status == 200) {
        this.restrictPastTripGeneration = success.body.restrictPastTripDate === true;
      }
    }, error => {
    });
  }

  isPastTripGenerationBlocked(): boolean {
    if (!this.restrictPastTripGeneration || !this.tripDate) {
      return false;
    }
    const selected = new Date(this.tripDate);
    selected.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return selected < today;
  }

}
